import sortBy from 'lodash/sortBy';
import { computed, makeObservable } from 'mobx';
import { ItemEdgeKind } from 'src/types/proto/transactions';
import Item, { ItemStore, TransactionItemJson } from './item';

export type SharePacketPublicationJson =
  TransactionItemJson<'SHARE_PACKET_PUBLICATION'>;

export default class SharePacketPublication extends Item<'SHARE_PACKET_PUBLICATION'> {
  constructor(store: ItemStore, json: SharePacketPublicationJson) {
    super(store, json);

    makeObservable(this);
  }

  get coverSheetUrl() {
    return this.kindItem.coverSheetUrl;
  }

  @computed
  get tdvIds() {
    return sortBy(
      this.outEdges.filter(
        (e) => e.kind === ItemEdgeKind.SHARE_PACKET_PUBLICATION_HAS_TDV
      ),
      (e) => e.data!.index
    ).map((e) => e.item2Id);
  }
}
